export const ShoppingListDataFragment = `
    id
    name
    is_editable
    ownable_type
    ownable_id
    ownable_name
`
